import React from "react"
import { Collapse, Grid, Typography, Chip, TextField, Tooltip } from "@material-ui/core"
import useStyles from "@/components/ExternalPlatformInput/styles"
import {
	InfoOutlined as InfoIcon
} from "@material-ui/icons"

type ExternalPlatformInputProps = {
	open: boolean
	value: string
	onChange: (v: string) => void
	label?: string
	placeholder?: string
	description?: string
	chipLabel?: string
}

const ExternalPlatformInput: React.FC<ExternalPlatformInputProps> = ({
	open,
	value,
	onChange,
	label = "Nome da Plataforma",
	placeholder = "Ex: Pluga, n8n, Make...",
	description = "Informe o nome da plataforma externa que enviará webhooks para a Letalk.",
	chipLabel = "Opcional"
}) => {
	const classes = useStyles()

	return (
		<Collapse in={open} timeout={300}>
			<Grid container direction="column" className={classes.root}>
				<Grid item>
					<Grid container direction="row" alignItems="center">
						<Grid item>
							<Typography className={classes.label}>{label}</Typography>
						</Grid>

						<Grid item>
							<Chip label={chipLabel} size="small" className={classes.chip} />
						</Grid>
					</Grid>
				</Grid>

				<Grid item>
					<Grid container direction="column" spacing={1}>
						<Grid item style={{ lineHeight: "14px" }}>
							<Grid container alignItems="center" spacing={1}>
								<Grid item>
									<Typography className={classes.description}>{description}</Typography>
								</Grid>

								<Grid item>
									<Tooltip
										title={"Informação para uso interno da Letalk, utilizada para identificar a origem dos webhooks recebidos e viabilizar futuras integrações nativas."}
									>
										<InfoIcon className={classes.icon} />
									</Tooltip>
								</Grid>
							</Grid>
						</Grid>

						<Grid item>
							<TextField
								variant="outlined"
								placeholder={placeholder}
								fullWidth
								value={value}
								onChange={({ target }) => onChange(target.value)}
							/>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Collapse>
	)
}

export default ExternalPlatformInput
